module.exports = __webpack_public_path__ + "static/media/oberflex-freneolivier-1200x2490.b0cc756b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-freneolivier-1200x2490.jpg
// module id = 1026
// module chunks = 37